import { angularServicesNames } from "@topline/services/angularServicesNames";

(module =>{
    "use strict";

    module.component('defenceSummary', {
        template: require('./defenceSummaryComponent.html'),
        bindings:{
            brand: "<"
        },
        controller: ['$scope', angularServicesNames.$translate, function(this: $TSFixMe, $scope: $TSFixMe, $translate: ng.translate.ITranslateService) {
            var $ctrl = this;

            $scope.$watch('$ctrl.brand', () => {
                if (!$ctrl.brand) {
                    return;
                }
                
                const { customData: { values } } = $ctrl.brand; 

                $ctrl.labels = values.labels;
                $ctrl.tableData = [
                    { header: $translate.instant('FORECAST.PRODUCT.DEFENCE.PRODUCT_FORECAST'), data: values.originalValues },
                    { header: $translate.instant('FORECAST.PRODUCT.DEFENCE.PRODUCT_DEFENCE'), data: values.customValues }
                 ];
            });      
        }]
    });


})(angular.module('topline.modules'));